import { ButtonIcon } from '@data-products-and-ai/react-components';
import React, { ReactNode } from 'react';

interface ModalProps {
  children: ReactNode;
  onClose: () => void;
  isOpen: boolean;
  title?: string;
}

const Modal: React.FC<ModalProps> = ({ children, onClose, isOpen, title }) => {
  return (
    isOpen && (
      <div className={`modal${isOpen ? ' open' : ''}`}>
        <div className="modal-mainContent">
          <div className="modal-mainContent_header">
            <h3>{title}</h3>
            <div data-testid="close-modal">
              <ButtonIcon
                buttonType="button"
                icon="IconClose"
                onClick={onClose}
                size="medium"
                hoverType="color"
              />
            </div>
          </div>
          <div className="modal-mainContent_body">{children}</div>
        </div>
      </div>
    )
  );
};

export default Modal;
